<script setup lang="ts">
import MmIcon from '../base/MmIcon.vue'
import MmSticker from '../base/MmSticker.vue'
defineProps<{ home?: boolean; banner?: boolean; covers?: string[] }>()
const { t } = useI18n()
</script>

<template>
  <section class="feed-entry mm-root" :class="{ 'feed-banner': banner }">
    <div class="feed-copy"><MmSticker v-if="banner" color="pink" :rotation="-2">{{ t('mm.new') }}</MmSticker><h2>{{ t(home ? 'mm.feed.freshDrops' : 'mm.feed.title') }}</h2><p>{{ t(banner ? 'mm.explore.feedDescription' : 'mm.feed.entryDescription') }}</p></div>
    <NuxtLink v-if="banner" to="/feed" :prefetch="false" class="btn btn-primary">{{ t('mm.explore.startSwiping') }}</NuxtLink>
    <NuxtLink v-if="!banner" to="/feed" :prefetch="false" class="btn btn-primary">{{ t('mm.feed.open') }}<MmIcon name="arrowR" :size="18" /></NuxtLink>
  </section>
</template>

<style scoped>
.feed-entry { display: flex; align-items: center; justify-content: space-between; gap: var(--s-4); flex-wrap: wrap; margin-block: var(--s-6); padding: var(--s-5); border: 1px solid var(--line-strong); border-radius: var(--r-lg); background: linear-gradient(120deg, var(--live-deep), var(--surface)); }
.feed-entry h2 { margin: 0 0 var(--s-2); font: 600 var(--t-h2)/1.3 var(--font-display); text-wrap: balance; }
.feed-entry p { max-width: 56ch; margin: 0; color: var(--text-2); font-size: var(--t-small); }
.feed-entry a { min-height: 44px; white-space: normal; }
.feed-entry .btn { font-size: 15px; }
.feed-copy { min-width: 0; }
.feed-banner { display: grid; gap: var(--s-6); margin-block: var(--s-8); padding: var(--s-6); border-radius: var(--r-xl); border-color: var(--line); overflow: hidden; background: radial-gradient(120% 140% at 0% 0%, var(--live-wash), transparent 60%), var(--surface); }
.feed-banner h2 { font: 700 var(--t-h2)/1.15 var(--font-display); letter-spacing: -.03em; margin: var(--s-3) 0 var(--s-2); }
.feed-banner p { max-width: 52ch; font-size: var(--t-body); }
.feed-banner > .btn { justify-self: start; max-width: 100%; text-align: center; }
@media(min-width:900px) { .feed-banner { grid-template-columns: minmax(0, 1fr) auto; align-items: center; min-height: 160px; padding: var(--s-8); } }
</style>
